import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { useStyles } from '../styles/NewOrUpdateForm.styles';

import type { Dispatch, SetStateAction } from 'react';

/** Generic CheckBox Components */
interface FormCheckBoxProps<State extends Record<any, any>, Key extends keyof State> {
    hidden?: boolean;
    stateKey: Key;
    label: string;
    draft: [State, Dispatch<SetStateAction<State>>];
    disabled?: boolean;
    values: {
        checked: State[Key];
        unchecked: State[Key];
    };
}

export const FormCheckBox = <State extends Record<any, any>, Key extends keyof State>({
    hidden,
    stateKey,
    label,
    disabled = false,
    draft,
    values,
}: FormCheckBoxProps<State, Key>) => {
    const [state, setState] = draft;
    const classes = useStyles();

    return (
        <Grid
            item
            md={4}
            sm={6}
            xs={12}
            className={classes.textInputWrapper}
            sx={{ display: hidden ? 'none' : undefined }}>
            <FormControlLabel
                control={
                    <Checkbox
                        disabled={disabled}
                        checked={state[stateKey] === values.checked}
                        onChange={(e) => {
                            setState((prev) => ({
                                ...prev,
                                [stateKey]: e.target.checked ? values.checked : values.unchecked,
                            }));
                        }}
                    />
                }
                label={label}
                sx={{ userSelect: 'none' }}
            />
        </Grid>
    );
};
